import { atom } from 'recoil';

// List of all available terms fetched from GET /api/terms
export const termsAtom = atom({
    key: 'terms',
    default: [],
});

// The currently selected term_id string, or null for "all terms / legacy"
export const currentTermAtom = atom({
    key: 'currentTerm',
    default: null,
});
